import { defineMessages } from 'react-intl';

export default defineMessages({
  edit: 'Edytuj',
  view: 'Zobacz',
  delete: 'Usuń',
});
